// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"752":"6d1617fc","882":"6d1617fc","897":"6d1617fc"}[chunkId] + ".chunk.css";
};